export const GENERIC_FORM_FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  SELECT: 'select',
  NOTES: 'notes',
  PHONE: 'phone',
  DATEPICKER: 'date_picker',
  TIMEPICKER: 'time_picker',
  CHECKBOX: 'checkbox',
  HEADING: 'heading'
}

export const createGenericFormField = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    label: null,
    type: GENERIC_FORM_FIELD_TYPES.TEXT,
    default: null,
    fullWidth: false,
    required: true,
    displayOrder: 0,
    options: [],
    multiple: false,
    includeTime: false
  }
}
